import axios from "axios";
import ApiService from "./api";

interface AddressSuggestion {
    title: string;
    id: string;
    resultType: string;
    address: {
        label: string;
        countryCode: string;
        countryName: string;
        state: string;
        county: string;
        city: string;
        district: string;
        street: string;
        postalCode: string;
        houseNumber: string;
    };
    position: {
        lat: number;
        lng: number;
    };
}

interface HereMapsResponseItem {
    title: string;
    id: string;
    resultType: string;
    address: {
        label: string;
        countryCode: string;
        countryName: string;
        state: string;
        county: string;
        city: string;
        district: string;
        street: string;
        postalCode: string;
        houseNumber: string;
    };
    position: {
        lat: number;
        lng: number;
    };
}

export const searchAddresses = async (
    address: string
): Promise<AddressSuggestion[]> => {
    const apiKey = import.meta.env.VITE_HERE_MAPS_API_KEY;
    const url = `https://geocode.search.hereapi.com/v1/geocode?q=${encodeURIComponent(
        address
    )}&apiKey=${apiKey}&limit=5`;

    try {
        const response = await axios(url);
        const data = response.data;

        if (data?.items) {
            return data.items.map((item: HereMapsResponseItem) => ({
                title: item.title,
                id: item.id,
                resultType: item.resultType,
                address: {
                    label: item.address.label,
                    countryCode: item.address.countryCode,
                    countryName: item.address.countryName,
                    state: item.address.state,
                    county: item.address.county,
                    city: item.address.city,
                    district: item.address.district,
                    street: item.address.street,
                    postalCode: item.address.postalCode,
                    houseNumber: item.address.houseNumber,
                },
                position: {
                    lat: item.position.lat,
                    lng: item.position.lng,
                },
            }));
        }
        return [];
    } catch (error) {
        console.error("Erro ao buscar geolocalização:", error);
        return [];
    }
};

export const getLatLng = async (address: string): Promise<{ lat: number, lng: number } | null> => {
    const apiKey = import.meta.env.VITE_HERE_MAPS_API_KEY;
    const url = `https://geocode.search.hereapi.com/v1/geocode?q=${encodeURIComponent(
        address
    )}&apiKey=${apiKey}`;

    try {
        const response = await axios(url);
        const data = response.data;

        return data.items[0].position;
    } catch (error) {
        console.error("Erro ao buscar geolocalização:", error);
        return null;
    }
}